var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentOverdueIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 54,
    viewBox: "0 0 55 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M0.804688 15.9622C0.804688 7.37412 7.7667 0.412109 16.3548 0.412109H38.5692C47.1573 0.412109 54.1193 7.37412 54.1193 15.9622V38.1766C54.1193 46.7647 47.1573 53.7267 38.5692 53.7267H16.3548C7.7667 53.7267 0.804688 46.7647 0.804688 38.1766V15.9622Z",
    fill: "#FF9066"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.78,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0491 21.1794C27.0735 20.8919 27.314 20.6709 27.6025 20.6709H28.0757C28.3588 20.6709 28.5967 20.884 28.6277 21.1654L29.3137 27.3927L34.1974 29.926C34.3815 30.0215 34.497 30.2116 34.497 30.419V30.7162C34.497 31.077 34.1584 31.342 33.8082 31.2553L26.8117 29.5232C26.5467 29.4576 26.3687 29.2092 26.3918 28.9372L27.0491 21.1794Z",
    fill: "#525252"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.901274,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5214 12.2736C20.213 11.9399 19.6247 12.06 19.5146 12.4791L17.7198 19.3095C17.6288 19.6559 17.9354 19.9886 18.3271 19.9684L26.0675 19.5702C26.5422 19.5458 26.7759 19.04 26.467 18.7058L24.4987 16.5764C25.7926 16.175 27.1647 15.9653 28.5735 15.9653C35.5258 15.9653 41.1617 21.0814 41.1617 27.3924C41.1617 33.7035 35.5258 38.8196 28.5735 38.8196C21.6213 38.8196 15.9854 33.7035 15.9854 27.3924C15.9854 26.333 16.1434 25.2953 16.4516 24.298L13.5997 23.5718C13.2242 24.787 13.0234 26.0684 13.0234 27.3924C13.0234 35.1884 19.9854 41.5083 28.5735 41.5083C37.1616 41.5083 44.1236 35.1884 44.1236 27.3924C44.1236 19.5965 37.1616 13.2766 28.5735 13.2766C26.4132 13.2766 24.3558 13.6765 22.4862 14.3992L20.5214 12.2736Z",
    fill: "#646464"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentOverdueIcon);
export default __webpack_public_path__ + "static/media/payment-overdue-icon.784878bea52fec243601364832b49c0e.svg";
export { ForwardRef as ReactComponent };